// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e2e_about_container{
  background:#050d3d;
  min-height:100vh;
  color:rgb(4, 35, 104);
}

.e2e_about_hero{
  position:relative;
  padding:120px 8%;
  background-image: url('https://images.unsplash.com/photo-1512403754473-27835f7b9984?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGNvbXBhbnl8ZW58MHx8MHx8fDA%3D');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.e2e_about_content{
  position:relative;
  z-index:2;
  max-width:750px;
}

.e2e_about_badge{
  color:#6246ec;
  font-weight:600;
}

.e2e_about_title{
  font-size:60px;
  line-height:1.2;
  margin-top:20px;
}

.e2e_about_description{
  margin-top:25px;
  color:#030f53;
  line-height:1.8;
}

.e2e_about_btn{
  margin-top:30px;
  border:none;
  padding:15px 35px;
  border-radius:12px;
  cursor:pointer;
  color:white;
  font-weight:600;
  background:linear-gradient(
  90deg,
  #8d39ff,
  #3968ff);
}

.e2e_about_stats_section{
  display:grid;
  grid-template-columns:repeat(4,1fr);
  gap:25px;
  padding:60px 8%;
  background-color: aliceblue;
}

.e2e_about_stat_card{
  background:rgba(255,255,255,.08);
  backdrop-filter:blur(20px);
  border-radius:20px;
  padding:30px;
  text-align:center;
}

.e2e_about_stat_card svg{
  font-size:35px;
  color:#ffffff;
}

.e2e_about_company{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:40px;
  padding:80px 8%;
  color: white;
}

.e2e_about_company_left ul{
  list-style:none;
  padding:0;
  color: white;
}

.e2e_about_company_left li{
  margin:15px 0;
  color: white;
}

.e2e_about_glass_card{
  background:rgb(255, 255, 255);
  backdrop-filter:blur(15px);
  border-radius:20px;
  padding:30px;
  margin-bottom:25px;
  color: blue;
}

.e2e_about_services{
  padding:80px 8%;
  background-color: aliceblue;
}

.e2e_about_section_title{
  text-align:center;
  margin-bottom:50px;
}

.e2e_about_services_grid{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:25px;
}

.e2e_about_service_card{
  background:rgba(255,255,255,.08);
  padding:30px;
  border-radius:20px;
  transition:.3s;
}

.e2e_about_service_card:hover{
  transform:translateY(-8px);
}

@media(max-width:768px){

.e2e_about_title{
  font-size:40px;
}

.e2e_about_company{
  grid-template-columns:1fr;
}

.e2e_about_stats_section{
  grid-template-columns:1fr;
}

.e2e_about_services_grid{
  grid-template-columns:1fr;
}

}`, "",{"version":3,"sources":["webpack://./src/styles/aboutpage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oMAAoM;EACpM,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,eAAe;EACf;;;UAGQ;AACV;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA","sourcesContent":[".e2e_about_container{\r\n  background:#050d3d;\r\n  min-height:100vh;\r\n  color:rgb(4, 35, 104);\r\n}\r\n\r\n.e2e_about_hero{\r\n  position:relative;\r\n  padding:120px 8%;\r\n  background-image: url('https://images.unsplash.com/photo-1512403754473-27835f7b9984?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGNvbXBhbnl8ZW58MHx8MHx8fDA%3D');\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-attachment: fixed;\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-attachment: fixed;\r\n}\r\n\r\n.e2e_about_content{\r\n  position:relative;\r\n  z-index:2;\r\n  max-width:750px;\r\n}\r\n\r\n.e2e_about_badge{\r\n  color:#6246ec;\r\n  font-weight:600;\r\n}\r\n\r\n.e2e_about_title{\r\n  font-size:60px;\r\n  line-height:1.2;\r\n  margin-top:20px;\r\n}\r\n\r\n.e2e_about_description{\r\n  margin-top:25px;\r\n  color:#030f53;\r\n  line-height:1.8;\r\n}\r\n\r\n.e2e_about_btn{\r\n  margin-top:30px;\r\n  border:none;\r\n  padding:15px 35px;\r\n  border-radius:12px;\r\n  cursor:pointer;\r\n  color:white;\r\n  font-weight:600;\r\n  background:linear-gradient(\r\n  90deg,\r\n  #8d39ff,\r\n  #3968ff);\r\n}\r\n\r\n.e2e_about_stats_section{\r\n  display:grid;\r\n  grid-template-columns:repeat(4,1fr);\r\n  gap:25px;\r\n  padding:60px 8%;\r\n  background-color: aliceblue;\r\n}\r\n\r\n.e2e_about_stat_card{\r\n  background:rgba(255,255,255,.08);\r\n  backdrop-filter:blur(20px);\r\n  border-radius:20px;\r\n  padding:30px;\r\n  text-align:center;\r\n}\r\n\r\n.e2e_about_stat_card svg{\r\n  font-size:35px;\r\n  color:#ffffff;\r\n}\r\n\r\n.e2e_about_company{\r\n  display:grid;\r\n  grid-template-columns:1fr 1fr;\r\n  gap:40px;\r\n  padding:80px 8%;\r\n  color: white;\r\n}\r\n\r\n.e2e_about_company_left ul{\r\n  list-style:none;\r\n  padding:0;\r\n  color: white;\r\n}\r\n\r\n.e2e_about_company_left li{\r\n  margin:15px 0;\r\n  color: white;\r\n}\r\n\r\n.e2e_about_glass_card{\r\n  background:rgb(255, 255, 255);\r\n  backdrop-filter:blur(15px);\r\n  border-radius:20px;\r\n  padding:30px;\r\n  margin-bottom:25px;\r\n  color: blue;\r\n}\r\n\r\n.e2e_about_services{\r\n  padding:80px 8%;\r\n  background-color: aliceblue;\r\n}\r\n\r\n.e2e_about_section_title{\r\n  text-align:center;\r\n  margin-bottom:50px;\r\n}\r\n\r\n.e2e_about_services_grid{\r\n  display:grid;\r\n  grid-template-columns:repeat(3,1fr);\r\n  gap:25px;\r\n}\r\n\r\n.e2e_about_service_card{\r\n  background:rgba(255,255,255,.08);\r\n  padding:30px;\r\n  border-radius:20px;\r\n  transition:.3s;\r\n}\r\n\r\n.e2e_about_service_card:hover{\r\n  transform:translateY(-8px);\r\n}\r\n\r\n@media(max-width:768px){\r\n\r\n.e2e_about_title{\r\n  font-size:40px;\r\n}\r\n\r\n.e2e_about_company{\r\n  grid-template-columns:1fr;\r\n}\r\n\r\n.e2e_about_stats_section{\r\n  grid-template-columns:1fr;\r\n}\r\n\r\n.e2e_about_services_grid{\r\n  grid-template-columns:1fr;\r\n}\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
